var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "modal", attrs: { id: "verify-vignette", tabindex: "-1" } },
    [
      _c("div", { staticClass: "modal-dialog modal-lg" }, [
        _c("div", { staticClass: "modal-content" }, [
          _c("div", { staticClass: "modal-header" }, [
            _c("h5", { staticClass: "modal-title" }, [
              _vm._v(_vm._s(_vm.$t("verify_vignette_title"))),
            ]),
            _vm._m(0),
          ]),
          _c("div", { ref: "modalBody", staticClass: "modal-body" }, [
            _c("iframe", {
              staticClass: "myIframe",
              staticStyle: { width: "100%" },
              attrs: {
                frameborder: "0",
                height: "350",
                id: "content",
                sandbox:
                  "allow-same-origin allow-downloads allow-scripts allow-forms",
                src: "https://www.erovinieta.ro/vgncheck/",
              },
            }),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "button",
      {
        staticClass: "close",
        attrs: {
          type: "button",
          "data-dismiss": "modal",
          "aria-label": "Close",
        },
      },
      [_c("div", { staticClass: "icon icon-x" })]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }